var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgArrowLeftCircle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 21,
  viewBox: "0 0 21 21",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1.5 -1.5)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 10,
  cy: 10,
  r: 10,
  transform: "translate(2 2)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M12,8,8,12l4,4"
}), /*#__PURE__*/React.createElement("line", {
  className: "a",
  x1: 8,
  transform: "translate(8 12)"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowLeftCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-left-circle.838dbc3e.svg";
export { ForwardRef as ReactComponent };